import { NgModule, ModuleWithProviders } from '@angular/core';

import {
  /* Componentes */
  PMVMainContentModule,
  PMVFieldsetModule,
  PMVConfirmDialogModule,
  PMVDatatableModule,
  PMVFileExportModule,
  PMVInputSearchModule,
  PMVLoadingModule,
  PMVModalModule,
  PMVSnackbarModule,
  PMVTextareaModule,
  PMVValidationModule,
  PMVAutocompleteModule,
  PMVCheckboxModule,
  PMVDateIntervalModule,
  PMVDatepickerModule,
  PMVDropdownModule,
  PMVFileUploadModule,
  PMVInputDecimalModule,
  PMVInputTextModule,
  PMVMaskModule,
  PMVRadioButtonModule,
  PMVTreeviewModule,

  /* Diretivas */
  PMVDirectiveModule,

  /* Pipes */
  PMVPipeModule,

  /* Serviços e outros */
  PMVUtilModule,
  PMVStorageModule,
  PMVInputNumberModule,
  PMVSingleFileUploadModule,
  PMVMaskCPFCNPJModule,
} from 'pmv-common';

const modules = [
  PMVMainContentModule,
  PMVFieldsetModule,
  PMVConfirmDialogModule,
  PMVDatatableModule,
  PMVFileExportModule,
  PMVInputSearchModule,
  PMVLoadingModule,
  PMVModalModule,
  PMVSnackbarModule,
  PMVTextareaModule,
  PMVValidationModule,
  PMVAutocompleteModule,
  PMVCheckboxModule,
  PMVDateIntervalModule,
  PMVDatepickerModule,
  PMVDropdownModule,
  PMVFileUploadModule,
  PMVInputDecimalModule,
  PMVInputTextModule,
  PMVMaskModule,
  PMVRadioButtonModule,
  PMVTreeviewModule,
  PMVInputNumberModule,
  PMVSingleFileUploadModule,
  PMVMaskCPFCNPJModule,
  
  PMVDirectiveModule,

  PMVPipeModule,
];

@NgModule({
  imports: [modules],
  exports: [modules],
})
export class PMVCommonModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: PMVCommonModule,
      providers: [
        ...PMVConfirmDialogModule.forRoot().providers,
        ...PMVFileExportModule.forRoot().providers,
        ...PMVSnackbarModule.forRoot().providers,

        ...PMVUtilModule.forRoot().providers,
        ...PMVStorageModule.forRoot().providers,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pmv-common.module.ts